export default __webpack_public_path__ + "static/foreground4-8aaa4f814160433320fb3e2cd2742190.webp";